import "../chunk-PKUHTIDK.js";
import { computedBarStyle } from "./index";
const api = ["state", "computedBarStyle"];
const renderless = (props, { inject, reactive }, { parent }) => {
  const state = reactive({
    rootTabs: inject("rootTabs"),
    barStyle: {}
  });
  const api2 = {
    state,
    computedBarStyle: computedBarStyle(parent)
  };
  return api2;
};
export {
  api,
  renderless
};
